import React, { useState, useEffect } from 'react';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const PhotoGalleryModal = ({ isOpen, onClose, folder }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    setCurrentIndex(0);
  }, [folder]);

  if (!isOpen || !folder || !folder.media) return null;

  const media = folder.media;
  const current = media[currentIndex];
  const isVideo = current.includes('.MP4') || current.includes('.MOV') || current.includes('.mp4') || current.includes('.mov');

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? media.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === media.length - 1 ? 0 : prev + 1));
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4">
      <div className="relative w-full max-w-4xl">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-20 inline-flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 p-2 text-white transition"
        >
          <FaTimes size={24} />
        </button>

        {/* Main Content */}
        <div className="relative bg-black rounded-lg overflow-hidden">
          <div className="relative aspect-video w-full overflow-hidden bg-black">
            {isVideo ? (
              <video
                key={current}
                controls
                autoPlay
                className="h-full w-full object-contain"
                src={`${process.env.PUBLIC_URL}/Photo Gallery/${current}`}
              />
            ) : (
              <img
                key={current}
                src={`${process.env.PUBLIC_URL}/Photo Gallery/${current}`}
                alt={`Gallery - ${currentIndex + 1}`}
                className="h-full w-full object-contain"
              />
            )}
          </div>

          {/* Previous Button */}
          <button
            onClick={goToPrevious}
            className="absolute left-4 top-1/2 -translate-y-1/2 inline-flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 p-3 text-white transition"
          >
            <FaChevronLeft size={20} />
          </button>

          {/* Next Button */}
          <button
            onClick={goToNext}
            className="absolute right-4 top-1/2 -translate-y-1/2 inline-flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 p-3 text-white transition"
          >
            <FaChevronRight size={20} />
          </button>

          {/* Counter */}
          <div className="absolute bottom-4 left-4 bg-black/50 rounded-full px-4 py-2 text-white text-sm font-semibold">
            {currentIndex + 1} / {media.length}
          </div>
        </div>

        {/* Thumbnail Strip */}
        <div className="mt-4 flex gap-2 overflow-x-auto pb-2">
          {media.map((item, index) => {
            const isItemVideo = item.includes('.MP4') || item.includes('.MOV') || item.includes('.mp4') || item.includes('.mov');
            return (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`flex-shrink-0 rounded-lg overflow-hidden transition ${
                  index === currentIndex ? 'ring-2 ring-primary' : 'opacity-60 hover:opacity-100'
                }`}
              >
                {isItemVideo ? (
                  <div className="h-16 w-20 bg-gray-700 flex items-center justify-center text-white text-xs font-semibold">
                    VIDEO
                  </div>
                ) : (
                  <img
                    src={`${process.env.PUBLIC_URL}/Photo Gallery/${item}`}
                    alt={`Thumbnail ${index + 1}`}
                    className="h-16 w-20 object-cover"
                  />
                )}
              </button>
            );
          })}
        </div>

        {/* Folder Info */}
        <div className="mt-4 text-center">
          <h3 className="text-white text-lg font-semibold">{folder.title}</h3>
          <p className="text-white/70 text-sm mt-1">{folder.description}</p>
        </div>
      </div>
    </div>
  );
};

export default PhotoGalleryModal;
